'use strict'

dealCardMarker = require '../models/deal_card_marker'

module.exports = Backbone.Collection.extend
  model: dealCardMarker
  url: '/browse/search/map'

  parse: (data) ->
    return [] unless data
    {mapCards} = data

    markers = []

    for card, index in mapCards
      continue unless card?
      card.index = index

      if card.locations?
        for location in card.locations
          markers.push {card, location}

    markers
